// SRV_Search_Market Version 1.2.1 date 16.03.24
(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
   typeof define === 'function' && define.amd ? define(factory) :
   (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.SRV_SMarket = factory());
}(this, (function () { 'use strict';

   // Default settings
   const defaults = {
      selmarket: '#floatsearchsmcat',
      selbrands: '#floatsearchsbrnd',
      mcat: undefined,
      name: undefined,
      catl: undefined,
      sid: undefined,
      id: undefined,
      step: undefined,
      ssize: undefined,
      proxy: '',
      script: '',
      onMarket: function(){}, // CallBack after Market load
      onBrands: function(){}, // CallBack after Brands load
   };

          //srt: "../cgi-bin/qwr_proxy.cgi?url=https://kommek.ru/cgi-bin/srv_search_scat.cgi",
   
   /**
   * Merge defaults with user options
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   * @returns {Object} Merged values of defaults and options
   */
 
   function extend(defaults, options ) {
      var extended = {};
      var prop;
      for (prop in defaults) {
         if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
             extended[prop] = defaults[prop];
         }
      }
      for (prop in options) {
         if (Object.prototype.hasOwnProperty.call(options, prop)) {
             extended[prop] = options[prop];
         }
      }
      return extended;
   }

   function search_market_mcat(srv_search_market,settings){
      var code = '';                // Category code
      var script = '';

      const url_mcat_param = new URLSearchParams();
  
      // Filter by category
      if ( typeof(settings.mcat) != 'undefined' && settings.mcat ) {
         code = settings.mcat;
         url_mcat_param.set('s_mcat',settings.mcat);
      }
      // The search bar
      if (typeof(settings.name) != 'undefined'){
         url_mcat_param.set('s_name',settings.name);
      }
      // Filter by brand    
      if ( typeof(settings.catl) != 'undefined' && settings.catl.indexOf('<!--VAR ') == -1 ){
         url_mcat_param.set('s_catl',settings.catl);
      }
      // SESSION ID parameter that allows you to save the current settings for transitions between page calls
      if ( typeof(settings.sid) != 'undefined' && settings.sid.indexOf('<!--VAR ') == -1) {
         url_mcat_param.set('sid',settings.sid);
      }
      // The code (ID) of the menu section where the search results are loaded. If the ID is not specified,
      // the load is performed in the menu with the search_market_mcat.tpl template
      if ( typeof(settings.id) != 'undefined' && !isNaN(settings.id) ) {
         url_mcat_param.set('id',settings.id);
      }
      if ( typeof(settings.step) != 'undefined' && !isNaN(settings.step) ) {
         url_mcat_param.set('step',settings.step);
      }
      if ( typeof(settings.sort) != 'undefined' && settings.sort.indexOf('<!--VAR ') == -1 ) {
         url_mcat_param.set('sort',settings.sort);
      }
      if ( typeof(settings.ssize) != 'undefined' && !isNaN(settings.ssize) ) {
         url_mcat_param.set('ssize',settings.ssize);
      }
      
      function floatSearch(url,name,callback) {
         if(code && script){
            var objFloat = document.querySelector(name);
            if (objFloat){
               kmkCMS.loadXMLDoc(url,objFloat,undefined,callback);
            }
         }
      }
      function afterMarket() {
         getbrand();
         if (settings.onMarket && typeof settings.onMarket === 'function') {
             settings.onMarket(srv_search_market);
         }
      }
      function afterBrands() {
         if (settings.onBrands && typeof settings.onBrands === 'function') {
             settings.onBrands(srv_search_market);
         }
      }
      function getbrand() {
         //const url = script+'?mode=s_brnd'+sid_cur+'%26htmhead=0';
         //script = settings.script + '?mode=s_brnd'+id_cur+sid_cur+'&htmhead=0';
         
         const script_url_brand = new URL(settings.script);
         script_url_brand.searchParams.set('mode','s_brnd');
         if(url_mcat_param.has('id')) script_url_brand.searchParams.set('id',url_mcat_param.get('id'));
         if(url_mcat_param.has('sid')) script_url_brand.searchParams.set('sid',url_mcat_param.get('sid'));
         script_url_brand.searchParams.set('htmhead',0);

         script = script_url_brand.href;
         const url = geturl(script);
         const name = settings.selbrands;
         //$(function() {
         //docReady(function() {floatSearch(url,name,showSearchBrand);});
         floatSearch(url,name,afterBrands);
      }
      function geturl(script){
         return (settings.proxy)? settings.proxy + encodeURIComponent(script):script;
      }
      
      //const url = script+'?s_mcat='+code+sid_cur+name_cur+catl_cur+'%26htmhead=0%26s_size=1%26ssize=40';
      //script = settings.script + '?s_mcat='+code+id_cur+sid_cur+name_cur+catl_cur+step_cur+sort_cur+ssize_cur+'&htmhead=0&s_size=1';
      
      url_mcat_param.set('htmhead',0);
      url_mcat_param.set('s_size',1);
      
      let script_mcat = new URL(settings.script);
      script_mcat.search = url_mcat_param;

      script = script_mcat.href;

      const url = geturl(script);
      const name = settings.selmarket;
      //docReady(function() { floatSearch(url,name,getbrand) });
      floatSearch(url,name,afterMarket);
   }
   
   /**
    * SRV_SMarket constructor
    */
   const SRV_SMarket = function (options) {
       const srv_search_market = {};
       // Merge user options with defaults
       let settings = extend( defaults, options || {} );
       srv_search_market.settings = settings;
       search_market_mcat(srv_search_market,settings);
       // Public APIs
       return srv_search_market;
   };

   return SRV_SMarket;

})));